<template>
  <div class="homeDataOpera" v-if="bdis">
    <div class="analysis_wrapper">
      <div class="analysis">
        <div class="logo_a">
          <i class="iconfont icon-transaction_fill"></i>
        </div>
        <div class="analy clearfix" @click="linkDetail">
          <div class="analy_t firstAnaly" style="">
            <p class="p1">{{$t('index_homeData_title')}}</p>
            <p class="p2">
              <small>￥</small>
              <template v-if="homeInfo.dis == 'w' && homeInfo.revenue> 10000">
                {{homeInfo.revenue | formatW }}
                <small>{{$t('tenThousand')}}</small>
              </template>
              <template v-else-if="homeInfo.dis == 'k' && homeInfo.revenue> 1000">
                {{homeInfo.revenue | formatK }}
                <small>K</small>
              </template>
              <template v-else>
                {{homeInfo.revenue}}
              </template>
            </p>
          </div>
          <div class="analy_t">
            <p class="p1">{{$t('index_homeData_analy')}}</p>
            <p class="p2">{{homeInfo.avl}}
              <small>{{$t('index_homeData_analy_unit')}}</small>
            </p>
          </div>
        </div>
        <div class="analysis_bottom clearfix">
          <div class="analy_t">
            <p class="p1">{{$t('index_homeData_analysis')}}</p>
            <p class="p2">{{homeInfo.rentRate}}
              <small>%</small>
            </p>
          </div>
          <div class="analy_t line">
            <span class="line_l"></span>
            <p class="p1">{{$t('index_homeData_analysis_avg')}}</p>
            <p class="p2">
              <small>￥</small>
              {{homeInfo.avgPrice}}
            </p>
            <span class="line_r"></span>
          </div>
          <div class="analy_t">
            <p class="p1">REVPAR 历程</p>
            <p class="p2">
              <small>￥</small>
              {{homeInfo.revPar}}
            </p>
          </div>
        </div>
        <div class="more"><i class="iconfont icon-you1"></i></div>
      </div>
    </div>

    <div id="angle" class="angle"></div>
    <div class="chartbottom clearfix">
      <div class="allNum">{{$t('index_homeData_angle_allNum')}}
        <div style="">{{homeInfo.ttl}}
          <small>{{$t('index_homeData_angle_allNum_unit')}}</small>
        </div>
      </div>
      <div style="float:left;width:4rem;">
        <div class="lenged">
          <div class="lengedTop">
            <div class="lengedcolor" style="background-color: #03c9cc"></div>
            <p>{{$t('index_homeData_angle_sort')}}</p></div>
          <p class="num">{{homeInfo.avl}}</p>
        </div>
        <div class="lenged">
          <div class="lengedTop">
            <div class="lengedcolor" style="background-color: #ffa500"></div>
            <p>{{$t('index_homeData_angle_takeUp')}}</p></div>
          <p class="num">{{homeInfo.occ}}</p>
        </div>
        <div class="lenged">
          <div class="lengedTop">
            <div class="lengedcolor" style="background-color: #e7737e"></div>
            <p v-if="isHuanQiu">
              {{$t('index_homeData_angle_lock_oo')}}
            </p>
            <p v-else>
              {{$t('index_homeData_angle_maintenance')}}
            </p>
          </div>
          <p class="num">{{homeInfo.ooo}}</p>
        </div>

        <div class="lenged">
          <div class="lengedTop">
            <div class="lengedcolor" style="background-color: #8a98b5"></div>
            <p  v-if="isHuanQiu">
              {{$t('index_homeData_angle_lock_os')}}
            </p>
            <p  v-else>{{$t('index_homeData_angle_lock')}}</p>
          </div>
          <p class="num">{{homeInfo.oos}}</p>
        </div>
      </div>
      <div class="tipBar">
        <router-link :to="'/opera/indexDesc'"><i class="iconfont icon-gantan"></i> {{$t('index_homeData_define')}}</router-link>
      </div>
      <div class="dx">
        {{$t('loading_end_message')}}
      </div>
    </div>
  </div>
</template>
<script>
  import echarts from "echarts";
  import {Toast, MessageBox} from "mint-ui";

  export default {
    props: {},
    data() {
      return {
        bdis: false,
        homeInfo: "",
        isHuanQiu: false,
      };
    },
    mounted() {
      // this.getGlobalPermission()
    },
    methods: {
      // getGlobalPermission(){
      //   this.$http.get("/mobilepmsapi/sysOptions/findOptionByOpen").then(res => {
      //     if (res.data.result == 0) {
      //       let retVal = res.data.retVal || {};
      //       this.isHuanQiu = retVal.isHuanQiu
      //     }
      //   });
      // },
      getData() {
        this.bdis = true;
        setTimeout(() => {
          this.disData();
        }, 10);
      },
      disData() {
        var echartFs = lib.flexible.rem2px([0.3]);
        var angle = document.getElementById("angle")
        if(!angle){
          return
        }
        document.getElementById("angle").style.width = window.innerWidth + 'px';
        var myChart = echarts.init(document.getElementById("angle"), "customed");
        // 绘制图表
        this.$http.post("/mobilepmsapi/licheng/homeInfo").then(res => {
          if (res.data.result == 0) {
            this.homeInfo = res.data.retVal;
            if (this.homeInfo.msg) {
              this.msg(this.homeInfo.msg);
            }
            var data = [
              {
                value: res.data.retVal.ooo,
                name: this.$t('index_homeData_angle_maintenance'),
                itemStyle: {normal: {color: "#e7737e"}}
              },
              {
                value: res.data.retVal.occ,
                name: this.$t('index_homeData_angle_takeUp'),
                itemStyle: {normal: {color: "#f69c2c"}}
              },
              {
                value: res.data.retVal.avl,
                name: this.$t('index_homeData_angle_sort'),
                itemStyle: {normal: {color: "#03c9cc"}}
              },
              {
                value: res.data.retVal.hse,
                name: this.$t('index_homeData_angle_personalUse'),
                itemStyle: {normal: {color: "#ba9fe2"}}
              },
              {
                value: res.data.retVal.com,
                name: this.$t('index_homeData_angle_free'),
                itemStyle: {normal: {color: "#2fb3f4"}}
              },
              {
                value: res.data.retVal.oos,
                name: this.$t('index_homeData_angle_lock'),
                itemStyle: {normal: {color: "#8a98b5"}}
              }
            ];
            for (var i = data.length - 1; i >= 0; i--) {
              if (data[i].value <= 0) {
                data.splice(i, 1);
              } else {
                data[i].name += ":" + data[i].value;
              }
            }
            var option = {
              // color:['#e7737e','#8a98b5','#03c9cc','#ba9fe2','#2fb3f4','#ffb576'],
              series: [
                {
                  name: this.$t('orderFromReport_chart_series_name'),
                  type: "pie",
                  radius: "70%",
                  center: ["50%", "50%"],
                  // roseType: "angle",
                  data: data,
                  itemStyle: {
                    normal: {
                      label: {
                        textStyle: {
                          fontSize: echartFs
                        }
                      }
                    }
                  }
                }
              ]
            };
            myChart.setOption(option);
          } else {
            this.msg(res.data.msg);
          }
        });
      },
      linkDetail() {
        // TODO
        return this.$router.push("/lichengIndexDetail");
      },
      msg(msg) {
        Toast({message: msg, position: "bottom", duration: 3000});
      }
    },
    filters: {
      formatW(value) {
        return (value / 10000).toFixed(2);
      },
      formatK(value) {
        return (value / 1000).toFixed(2);
      }
    }
  };
</script>
<style lang='less'>
  .homeDataOpera {
    .angle {
      height: 7rem;
      width: 10rem;
      margin-top: .3rem;
      background: #fff;
      display: inline-block;
    }

    .analysis {
      background: #f6f8f9;
      width: 100%;
      position: relative;
      top: -1px;
      box-sizing: border-box;
      padding: 0.3rem 0.13333333rem 0 0;
      background-image: linear-gradient(to top, #ff6e61, #ffa500);

      .more {
        position: absolute;
        right: 5px;
        top: 1.7rem;
        color: #fff;

        i {
          font-size: 0.7rem;
        }
      }

      .logo_a {
        width: 2.34666667rem;
        float: left;
        text-align: center;
        line-height: 1.86666667rem;
        height: 1.86666667rem;

        .iconfont {
          font-size: 1.33333333rem;
          color: #fff;
        }
      }

      .analy {
        .firstAnaly {
          width: 4.13333333rem;
          float: left;
          text-align: left;
        }
      }

      .analy_t {
        float: left;
        width: 33%;
        text-align: center;
        color: #fff;
        height: 50%;
        font-family: PingFangSC-Regular;

        .p1 {
          margin: 0 auto;
          margin-top: 0.26666667rem;
          height: 0.4rem;
          line-height: 0.4rem;
          font-size: 0.32rem;
          position: relative;

          width: ~"calc(100% - 4px)";
        }

        .p2 {
          margin: 0 auto;
          font-size: 0.64rem;
          line-height: 1.06666667rem;
          height: 1.2rem;
          position: relative;

          width: ~"calc(100% - 2px)";
          margin: 0 auto;

          small {
            vertical-align: baseline;
            font-size: 0.32rem;
            -webkit-transform-origin-x: 0;
            -webkit-transform: scale(0.6);
          }
        }

        &.line {
          position: relative;

          .line_l {
            position: absolute;
            width: 1px;
            height: 0.58666667rem;
            background: #fff;
            left: 0;
            top: 0.66666667rem;
            z-index: 1;
          }

          .line_r {
            position: absolute;
            width: 1px;
            height: 0.58666667rem;
            right: 0;
            top: 0.66666667rem;
            background: #fff;
            z-index: 1;
          }
        }
      }
    }

    .chartbottom {
      padding: 0 0.4rem;
      margin-bottom: 1.28rem;

      .allNum {
        margin-top: 0.26666667rem;
        width: 4rem;
        height: 0.90666667rem;
        border-radius: 0.45333333rem;
        float: left;
        background-color: #ededed;
        line-height: 0.90666667rem;
        font-size: 0.5rem;
        line-height: 1.2rem;
        text-align: center;
        margin-right: 0.58666667rem;
        height: 2.8rem;

        div {
          margin: 0 0.13333333rem 0 0.18666667rem;
          font-size: 0.7rem;
        }

        small {

          display: inline-block;
          transform-origin-x: center;
          transform: scale(0.9);
        }
      }

      .lenged {
        float: left;
        width: 50%;
        height: 1.33333333rem;
        padding: 0.13333333rem 0;

        .lengedTop {
          height: 0.53333333rem;
          line-height: 0.53333333rem;

          .lengedcolor {
            width: 0.53333333rem;
            height: 0.26666667rem;
            margin-top: 0.13333333rem;
            border-radius: 0.08rem;
            margin-left: 0.13333333rem;
            float: left;
          }

          p {
            margin-left: 0.16rem;
            float: left;
            text-align: left;
          }
        }

        .num {
          text-align: center;
          font-size: 0.48rem;
          line-height: 0.8rem;
        }
      }
    }

    .analysis_wrapper {
      padding: 10px 0;
      background-color: #f6f8f9;
    }

    .tipBar {
      padding: 10px 0 0;
      clear: both;
      font-size: 0.32rem;
      text-align: right;
    }

    .tipBar a {
      color: #b2c1cc;
    }

    .dx {
      padding-bottom: 10px;
      text-align: center;
      height: 20px;
      margin-top: 20px;
      line-height: 20px;
      color: #eee;

      span {
        color: #ddd;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// HomeData.vue?f5956b0e